import { Card, SimpleGrid, Stack, Text } from "@mantine/core"
import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * The card-grid body for the world-entity CRUD screens: a responsive
 * SimpleGrid (1 / 2 / 3 columns) of per-entity cards, or an empty-state card
 * when the filtered list is empty. Each entity supplies its own card markup
 * through `renderCard`; the grid owns only the layout + empty state.
 *
 * Locations' tree layout is a sibling of this grid, not a mode of it — the
 * view renders its own Tree card when in tree mode and falls back to this grid
 * (which also covers the empty case) otherwise.
 */
export function WorldEntityGrid<TItem>({ items, renderCard, emptyMessage }: IProps<TItem>): React.JSX.Element {
  if (items.length === 0) {
    return (
      <Card withBorder padding="lg" className={classes.empty}>
        <Stack align="center" gap="xs">
          <Text c="dimmed" fz="sm">
            {emptyMessage}
          </Text>
        </Stack>
      </Card>
    )
  }

  return <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>{items.map((item) => renderCard(item))}</SimpleGrid>
}
